import React, { useLayoutEffect, useRef } from "react";
import ActiveCallWidget from "./ActiveCallWidget";
import { useInquiryDocumentPanel } from "../../../contexts/InquiryDocumentPanelContext";

type IActiveWidgetBase = Omit<
  React.ComponentProps<typeof ActiveCallWidget>,
  "onOpenCard"
>;

/**
 * Wired to the global inquiry document drawer so "open card" works on any route.
 */
const ActiveCallWidgetWithCard: React.FC<IActiveWidgetBase> = (props) => {
  const { openInquiryDocumentForActiveCall, openPostCallInquiryDocument } =
    useInquiryDocumentPanel();
  const postCallAutoOpenedRef = useRef(false);

  useLayoutEffect(() => {
    if (!props.isRemoteEndedPhase) {
      postCallAutoOpenedRef.current = false;
      return;
    }
    if (postCallAutoOpenedRef.current) {
      return;
    }
    postCallAutoOpenedRef.current = true;
    openPostCallInquiryDocument();
  }, [props.isRemoteEndedPhase, openPostCallInquiryDocument]);

  return (
    <ActiveCallWidget
      {...props}
      onOpenCard={() => {
        openInquiryDocumentForActiveCall();
      }}
    />
  );
};

export default ActiveCallWidgetWithCard;
